<template>
    <div>
        <div>
            <canvas class="w-full" id="canvas" ref="canvas"></canvas>
        </div>
        <div class="flex justify-end mr-4" v-show="showExport">
            <button-primary @click="downloadPDF()">
                <template slot="icon"><i class="fa fa-download"></i></template>
                PDF
            </button-primary>
        </div>
    </div>
</template>

<script>
import ExportChart from '../Chart/ExportChart';
import Chart from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ButtonPrimary from '../UI/ButtonPrimary';

Chart.plugins.unregister(ChartDataLabels);

export default {
    name: "ChartBarLineStacked",

    components: {
        ButtonPrimary,
    },

    mixins: [ExportChart],

    props: {
        bookings: {},
        desks: {},
        permanentBookings: {},
        users: {},
        'headline': {
            default: 'Headline',
        },
        labels: {},
        colors: {
            default: () => ([
                '#F1948A',
                '#F9E79F',
                '#FAD7A0',
                '#A0C4FF',
            ]),
        },
        showExport: {
            type: Boolean,
            default: true,
        }
    },


    watch: {
        json() {
            this.chart();
        }
    },


    computed: {
        json() {
            return {
                type: 'bar',
                data: {
                    labels: this.labels,
                    datasets: [
                        {
                            type: 'line',
                            label: 'Benutzeranzahl',
                            data: this.users,
                            borderColor: this.colors[3],
                            fill: false,
                            tension: 0.1,
                        },
                        {
                            type: 'line',
                            label: 'Schreibtischanzahl',
                            data: this.desks,
                            borderColor: this.colors[0],
                            fill: false,
                            tension: 0.1,
                        },
                        {
                            label: 'Dauerhaft gebuchte Schreibtische',
                            data: this.permanentBookings,
                            backgroundColor: this.colors[1],
                            stack: 'combined'
                        },
                        {
                            label: 'Täglich gebuchte Schreibtische',
                            data: this.bookings,
                            backgroundColor: this.colors[2],
                            stack: 'combined'
                        },
                    ]
                },
                options: {
                    responsive: true,
                    plugins: {
                        // Change options for ALL labels of THIS CHART
                        datalabels: {
                            //color: 'black',
                            //anchor: 'end',
                            //align: 'end',
                            //offset: 40,
                        }
                    },
                    legend: {
                        display: true,
                    },
                    title: {
                        display: false,
                        text: 'Chart.js Line Chart'
                    },
                    scales: {
                        xAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: 'Zeit'
                            }
                        }],
                        yAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: 'Anzahl'
                            }
                        }],
                        x: {
                            title: {
                                display: true,
                                text: 'Anzahl'
                            },
                            stacked: true
                        },
                        y: {
                            title: {
                                display: true,
                                text: 'Zeit'
                            },
                            stacked: true,
                        }
                    }
                }
            };
        }
    },

    mounted() {
        this.chart()
    },

    methods: {
        chart() {
            new Chart(this.$refs.canvas, this.json);
        }
    }
}
</script>

<style scoped>

</style>
